import { Object3D, PerspectiveCamera, Vector2, Vector3 } from 'three';

export function normalizePointerTo3D(
  x: number,
  y: number,
  width: number,
  height: number,
  vector: Vector2
) {
  return vector.set((x / width) * 2 - 1, -(y / height) * 2 + 1);
}
export function normalizePointerTo2D(
  obj: Object3D, camera: PerspectiveCamera, width: number, height: number
) {
  const vector = new Vector3();

  const widthHalf = 0.5 * width;
  const heightHalf = 0.5 * height;

  obj.updateMatrixWorld();
  vector.setFromMatrixPosition(obj.matrixWorld);
  vector.project(camera);

  vector.x = ( vector.x * widthHalf ) + widthHalf;
  vector.y = - ( vector.y * heightHalf ) + heightHalf;
  
  return {
    x: vector.x,
    y: vector.y,
  };
}
